import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules'

export const CardsSwiper = ({ data }: { data: any }) => {
  return (
    <section className={data.className + ' -mt-[210px]'}>
      <div className="md:max-w-content">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={8}
          slidesPerView={2}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          watchSlidesProgress={true}
          className="reviewSlider !overflow-visible"
        >
          {data.items.map((item: any, index: number) => (
            <SwiperSlide
              key={index}
              className="min-h-full !h-[unset] bg-[#F6F6F7] rounded-[24px] p-6"
            >
              {item.icon && (
                <figure className="relative w-8 h-8 rounded-full">
                  <img src={item.icon} alt={item.title} className="w-full h-[auto]" />
                </figure>
              )}
              <h3 className="text-base font-semibold leading-[1.4] mt-4">{item.title}</h3>
              {item.description && <p>{item.description}</p>}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  )
}
